import DomiansOfBusiness from './business';
import DomainsOfCommon from './common';

const DomianInfos = {
	...DomainsOfCommon,
	...DomiansOfBusiness,
};

export default DomianInfos;
